<template>
  <div>
    <div class="card-actions card mb-6">
      <div class="card-content flex md:flex-row flex-col space-y-2 md:space-y-0 justify-between items-center">
        <h2 class="text-2xl my-0 font-bold">
          Manage SNS Templates
        </h2>
        <button
          class="button primary"
          @click="addDialog = true"
        >
          Add SMS Template
        </button>
      </div>
    </div>

    <div
      v-if="!smsTemplates.length"
      class="w-full text-center text-xl font-medium text-gray-400"
    >
      No Templates yet
    </div>

    <div
      v-else
      class="space-y-4"
    >
      <div
        v-for="(item, index) of smsTemplates"
        :key="index"
        class="card p-4 border-l-4 border-muted-300 flex justify-between items-center"
      >
        <span>
          {{ item.name }}
        </span>

        <div>
          <div
            class="dropdown"
            :class="{ 'is-active': item.show_menu }"
          >
            <div class="dropdown-trigger">
              <button
                class="button is-white"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
                @click="item.show_menu = !item.show_menu"
              >
                <span class="icon is-small">
                  <i
                    class="fas fa-ellipsis-v"
                    aria-hidden="true"
                  />
                </span>
              </button>
            </div>
            <div
              id="dropdown-menu"
              class="dropdown-menu"
              role="menu"
            >
              <div class="dropdown-content">
                <button
                  class="dropdown-item"
                  @click="handleEdit(item)"
                >
                  Edit
                </button>
                <button
                  class="dropdown-item text-red-500"
                  @click="handleDelete(item)"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal add-admin"
      :class="{'is-active' : addDialog}"
    >
      <div
        class="modal-background"
        @click="hideAddModal()"
      />
      <div class="modal-content w-full md:w-4/5 xl:w-2/3 2xl:w-1/2">
        <div class="box">
          <h5 class="">
            {{ isEditMode ? 'Edit' : 'Add' }} SMS Template
          </h5>

          <!-- Dialog Form here -->
          <div class="flex flex-col md:flex-row space-x-2 w-full h-[58vh]">
            <div class="w-full md:w-1/2">
              <div class="field">
                <div class="control">
                  <label
                    class="label"
                    for="sms-name"
                  >
                    <span>Name</span>
                  </label>
                  <input
                    id="sms-name"
                    v-model="v$.name.$model"
                    class="input is-mandatory"
                    :class="{ '!border-red-600': v$.name.$error }"
                    type="text"
                    placeholder="Template Name"
                  >
                  <div class="h-[10px] text-red-600 text-xs">
                    <span v-if="v$.name.$error">{{ v$.name.$errors[0].$message }}</span>
                  </div>
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <label
                    class="label"
                    for="sms-template"
                  >Template</label>
                  <textarea
                    id="sms-template"
                    v-model="v$.template.$model"
                    :class="{ '!border-red-600': v$.template.$error }"
                    class="input is-mandatory h-48 md:h-96"
                  />
                  <div class="h-[10px] text-red-600 text-xs">
                    <span v-if="v$.template.$error">{{ v$.template.$errors[0].$message }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full md:w-1/2 overflow-y-scroll overflow-x-hidden relative">
              <h6 class="sticky top-0 left-0 bg-white dark:bg-muted-800 m-0 pt-4 pb-2">Available Placeholders</h6>
              <div class="space-y-2 placeholders-container ">
                <div
                  v-for="(placeholder, index) in templatePlaceholders"
                  :key="index"
                  class="grid grid-cols-2 gap-2 border-b border-gray-200 pb-2 items-center"
                >
                  <input
                    class="small cursor-pointer"
                    type="text"
                    :value="placeholder.name"
                    readonly
                    @click="copyPlaceholder($event, placeholder.name)"
                  >

                  <div class="text-gray-500 dark:text-muted-200 text-xs">
                    {{ placeholder.description }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="control actions flex space-x-4 justify-end mt-2 pt-2 border-t">
            <button
              type="button"
              class="button is-outlined"
              :disabled="loading"
              @click="hideAddModal()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="button primary"
              :disabled="loading"
              @click="addSMSTemplate()"
            >
              {{ isEditMode ? 'Save' : 'Add' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      style="z-index: 9999"
      :class="{ 'is-active': deleteDialog }"
    >
      <div
        class="modal-background"
        @click="deleteHandler(true)"
      />

      <div
        class="modal-content w-80 bg-muted-50 dark:bg-muted-800 p-5 pt-3 rounded flex flex-col justify-between"
      >
        <div>
          <h5>Caution!</h5>
          <p class="text-sm">
            Are you sure you want to delete this SMS Template?
          </p>

          <div class="text-sm mt-2 space-y-2">
            <dd class="flex flex-col justify-between">
              <b>Name:</b>
              <div>
                {{ activeTemplate?.name }}
              </div>
            </dd>
            <dd class="flex flex-col justify-between">
              <b>Template:</b>
              <div v-html="activeTemplate?.template" />
            </dd>
          </div>
        </div>

        <div class="flex justify-between space-x-2">
          <button
            class="mt-3 py-2 rounded w-full text-gray-500 border border-gray-500"
            :disabled="loading"
            @click="deleteHandler(true)"
          >
            Cancel
          </button>
          <button
            class="mt-3 bg-red-500 hover:bg-red-600 py-2 rounded text-white w-full"
            :disabled="loading"
            @click="deleteHandler()"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue, { reactive } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default Vue.extend({
  name: 'SMSTemplatesComponent',
  setup() {
    const state = reactive({
      name: '',
      template: ''
    });

    const rules = {
      name: { required },
      template: { required }
    };

    const v$ = useVuelidate(rules, state, { $autoDirty: true });

    return { state, v$ };
  },
  data: () => ({
    addDialog: false,
    deleteDialog: false,
    activeTemplate: null,
    loading: false
  }),
  computed: {
    isEditMode() {
      return !!this.activeTemplate;
    },
    templatePlaceholders() {
      return this.$store.getters['common/getTemplatePlaceholders'];
    },
    smsTemplates() {
      return this.$store.getters['workflow/getSMSTemplatesFull'];
    }
  },
  async mounted() {
    await Promise.all([
      this.$store.dispatch('common/fetchTemplatePlaceholders'),
      this.$store.dispatch('workflow/fetchSMSTemplates', { id: this.$store.state.selectedOrganization.uuid })
    ]);
  },
  beforeDestroy() {
    this.$store.commit('workflow/setSMSTemplates', []);
  },
  methods: {
    handleEdit({ name, template, uuid }) {
      this.activeTemplate = uuid;
      this.v$.name.$model = name;
      this.v$.template.$model = template;
      this.addDialog = true;
    },
    hideAddModal() {
      this.addDialog = false;
      this.activeTemplate = null;
      this.v$.name.$model = '';
      this.v$.template.$model = '';
      this.v$.$reset();
    },
    async addSMSTemplate() {
      if (this.v$.$invalid) {
        return;
      }

      try {
        this.loading = true;

        if (!this.isEditMode) {
          await this.$store.dispatch('workflow/createSMSTemplate', {
            id: this.$store.state.selectedOrganization.uuid,
            payload: {
              name: this.v$.name.$model,
              template: this.v$.template.$model
            }
          });

          this.$root.$emit('showToast', { message: 'Template created', options: { cssClass: 'is-success', duration: 5000 } });
        }

        if (this.isEditMode) {
          await this.$store.dispatch('workflow/updateSMSTemplate', {
            uuid: this.activeTemplate,
            name: this.v$.name.$model,
            template: this.v$.template.$model
          });

          this.$root.$emit('showToast', { message: 'Template updated', options: { cssClass: 'is-success', duration: 5000 } });
        }

        window.location.reload();
      } catch (error) {
        this.$root.$emit('showToast', { message: 'Something went wrong, please try again later', options: { cssClass: 'is-danger', duration: 10000 } });
      } finally {
        this.loading = false;
      }
    },
    handleDelete(template) {
      this.activeTemplate = template;
      this.deleteDialog = true;
    },
    async deleteHandler(isClose = false) {
      if (!isClose) {
        try {
          this.loading = true;
          await this.$store.dispatch('workflow/deleteSMSTemplate', this.activeTemplate.uuid);
          this.$root.$emit('showToast', { message: 'Template deleted', options: { cssClass: 'is-success', duration: 5000 } });
          window.location.reload();
        } catch (error) {
          this.$root.$emit('showToast', { message: 'Something went wrong, please try again later', options: { cssClass: 'is-danger', duration: 10000 } });
        } finally {
          this.loading = false;
        }
      }

      this.deleteDialog = false;
      this.activeTemplate = null;
    },
    copyPlaceholder(e, name) {
      e.target.select();
      document.execCommand('copy');
      this.$root.$emit('showToast', { message: `<b>${name}</b> copied to clipboard`, options: { cssClass: 'is-link', duration: 5000 } });
    }
  }
});
</script>

<style lang="scss" scoped>
.title {
  @apply my-0;
}

.placeholders-container {
  max-height: 30vh;
}

.modal-content {
  max-height: 100vh;
  .box {
    height: 100vh;
  }
}

@screen md {
  .modal-content {
    max-height: calc(100vh - 160px);

    .box {
      height: auto;
    }
  }
}

</style>
